import React from "react";
import { Construction } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Slim top announcement bar shown site-wide.
 * To remove: delete <MaintenanceBanner /> from Layout.tsx.
 */
const MaintenanceBanner: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="w-full bg-amber-500 text-navy-950 text-sm font-semibold py-2 px-4 flex items-center justify-center gap-2 text-center">
      <Construction size={15} strokeWidth={2.5} className="shrink-0" />
      <span>{t("maintenanceBanner.text")}</span>
    </div>
  );
};

export default MaintenanceBanner;
